// extracted by mini-css-extract-plugin
export default {"root":"LandingMenu_root__AsKI3","content":"LandingMenu_content__6TE3N","playIcon":"LandingMenu_playIcon__tPmoj","button":"LandingMenu_button__RiU--","logo":"LandingMenu_logo__AfIaf"};